import { useParams, Link } from 'react-router-dom'
import { getAllCategories, getArticlesByCategory } from '../data/articles'
import './StaticPages.css'

function slugToKey(slug){
  return slug.replace(/-/g,' ').toLowerCase()
}

function CategoryPage(){
  const { slug } = useParams()
  const categories = getAllCategories()
  const mapped = categories.find(c => slugToKey(c) === slugToKey(slug)) || null
  const articles = mapped ? getArticlesByCategory(mapped) : []

  return (
    <main className="static-page">
      <div className="container">
        <h1>{mapped || 'Category'}</h1>
        {articles.length === 0 ? (
          <p>No articles found for this category.</p>
        ) : (
          <ul className="category-articles">
            {articles.map(a => (
              <li key={a.slug}>
                <Link to={`/article/${a.slug}`}>{a.title}</Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </main>
  )
}

export default CategoryPage
